<template>
  <el-form label-position="right" label-width="100px">
    <el-form-item v-for="column in columns" :key="column.prop" :label="column.label">
      <el-input v-model="group[column.prop]" :rows="column.row" :type="column.type" readonly></el-input>
    </el-form-item>
  </el-form>
</template>
<script>
import { defineComponent } from "vue";
export default defineComponent({
  data() {
    return {
      columns: [
        { label: '班组负责人:', prop: 'groupName' },
        { label: '所属单位名称:', prop: 'directorName' },
        { label: '负责人电话:', prop: 'directorPhone' },
        { label: '工种:', prop: 'typeOfWorkName' },
        { label: '班组介绍:', prop: 'electronicFence', type: 'textarea', rows: 3 }
      ]
    };
  },
  props: {
    group: Object
  }
});
</script>